import { render, staticRenderFns } from "./staffEdit.vue?vue&type=template&id=f68b3534&scoped=true"
import script from "./staffEdit?vue&type=script&lang=js&external"
export * from "./staffEdit?vue&type=script&lang=js&external"
import style0 from "./staffEdit.vue?vue&type=style&index=0&id=f68b3534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68b3534",
  null
  
)

export default component.exports